import React from 'react'
import PropTypes from 'prop-types'

import { Card, List } from 'semantic-ui-react'

import CardPropertyLink from 'Components/CardPropertyLink'

import { buildCustomerString, buildCustomerStringFull } from 'Global/Helpers/familyAlbumHelpers'

const FAPictureCardCustomers = ({ picture }) => {
  const mappedCustomers = picture.customers.map(customer => {
    return (
      <CardPropertyLink
        icon="user"
        key={customer.id}
        linkTo={`/familyAlbum/search?email=${customer.email}`}
        popUpContent={buildCustomerStringFull(customer)}
      >
        {buildCustomerString(customer)}
      </CardPropertyLink>
    )
  })

  return (
    <Card.Content extra>
      <List>{mappedCustomers}</List>
    </Card.Content>
  )
}

FAPictureCardCustomers.propTypes = {
  picture: PropTypes.object.isRequired,
}

export default FAPictureCardCustomers
